/**
 * Who a User level template is shared with, as spt keeps it on the template
 * (`access_members`): [{ mondayUserId, mondayUserName }]. Access goes by id;
 * the name is a label as of the last save, shown when the person is no longer
 * among the account's users.
 */

/** The template's list, cleaned: distinct positive ids, in order. */
export function accessMembersOf(template) {
  const raw = template && Array.isArray(template.access_members) ? template.access_members : [];
  const out = [];
  for (const m of raw) {
    const id = Number(m && m.mondayUserId);
    if (!Number.isInteger(id) || id <= 0 || out.some((x) => x.mondayUserId === id)) continue;
    out.push({ mondayUserId: id, mondayUserName: m && typeof m.mondayUserName === 'string' ? m.mondayUserName : '' });
  }
  return out;
}

/** The list with each name refreshed from the account's users ({ id, name }) where they are known. */
export function withCurrentNames(members, users) {
  return (members || []).map((m) => {
    const user = (users || []).find((u) => String(u.id) === String(m.mondayUserId));
    return user && user.name ? { ...m, mondayUserName: user.name } : m;
  });
}
